var _defs, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew234({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.87,7.26a1.32,1.32,0,0,1-.1.51,1.25,1.25,0,0,1-.29.44A1.44,1.44,0,0,1,5,8.53a2,2,0,0,1-.74.12H3.72v1.49H3.15V6H4.32a2.32,2.32,0,0,1,.59.07,1.37,1.37,0,0,1,.49.22,1.07,1.07,0,0,1,.34.39A1.18,1.18,0,0,1,5.87,7.26Zm-.59,0A.72.72,0,0,0,5,6.68a1.13,1.13,0,0,0-.73-.21H3.72v1.7h.52A1.16,1.16,0,0,0,5,8,.78.78,0,0,0,5.28,7.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.55,8a3.48,3.48,0,0,1,0,.57,2.74,2.74,0,0,1-.15.51,2,2,0,0,1-.26.42,1.44,1.44,0,0,1-.4.33,2.1,2.1,0,0,1-.55.21,2.93,2.93,0,0,1-.7.08H6.56V6H7.63a1.89,1.89,0,0,1,1.44.5A2.12,2.12,0,0,1,9.55,8ZM9,8.06a3.1,3.1,0,0,0-.08-.74,1.26,1.26,0,0,0-.25-.49,1,1,0,0,0-.42-.27,1.8,1.8,0,0,0-.6-.09H7.13V9.65h.42Q9,9.65,9,8.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13,10.14h-.56V8.24H10.7v1.9h-.57V6h.57V7.75h1.74V6H13Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 3.7,
    width: 15,
    height: 8.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew234);
export default __webpack_public_path__ + "static/media/Symbolpack_New_234.0642336a7bd08f1d84b11c4144269327.svg";
export { ForwardRef as ReactComponent };